<template>
  <div class="flex flex-col sm:flex-row items-center justify-center text-center">
    <div
      v-for="(counter, index) in counters"
      :key="index"
      class="flex flex-col flex-1 items-center justify-center text-center gap-4 mb-8 last:mb-0 sm:mb-0 sm:border-r last:border-0 px-6"
    >
      <p :class="cn('text-7xl font-semibold', props.class)">
        <span>{{ counter.number }}</span>
        <span v-if="counter.unit">{{ counter.unit }}</span>
      </p>
      <p v-if="counter.description" class="max-w-3/4 text-grey-dark-300">
        {{ counter.description }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import type { HTMLAttributes } from 'vue';

interface Counter {
  number: number;
  unit?: string;
  description?: string;
}

interface Props {
  counters: Counter[];
  class?: HTMLAttributes['class'];
}
const props = defineProps<Props>();
</script>
